<template>
  <section>
    <b-row>
      <b-col md="12">
        <h2>
          Alertas
          <small v-if="$auth.can('agregar_alertas')">
            <b-link href @click.prevent="agregar">Agregar</b-link>
          </small>
        </h2>

        <b-table responsive striped hover :items="alertas" :fields="campos">
          <template #cell(tipo)="data">{{ textoTipo( data.value ) }}</template>
          <template #cell(accion)="data">{{ textoAccion( data.value ) }}</template>
          <template #cell(correos)="data">
            <div>
              <b-badge pill v-for="item in data.value" :key="item" variant="info">{{ item }}</b-badge>
            </div>
          </template>
          <template #cell(acciones)="row">
            <b-link href @click.prevent="editar(row.item)" v-if="$auth.can('editar_alertas')">Editar</b-link>
            <b-link href @click.prevent="eliminar(row.item)" v-if="$auth.can('eliminar_alertas')">Eliminar</b-link>
          </template>
        </b-table>

      </b-col>
    </b-row>

    <!-- Modal Agregar Alerta -->
    <b-modal v-model="mainModal" size="lg" no-close-on-backdrop>

      <b-form ref="mainForm" @submit.prevent="guardar">
        <b-form-group label="Descripción:" label-for="input-descripcion" :invalid-feedback="errores.descripcion">
          <b-form-input id="input-descripcion" v-model="alerta.descripcion" :state="$empty(errores.descripcion)" trim></b-form-input>
          <b-form-text>Breve descripción de la alerta</b-form-text>
        </b-form-group>

        <b-form-group label="Identificador de alerta:" label-for="input-identificador" :invalid-feedback="errores.identificador">
          <b-form-input id="input-identificador" v-model="alerta.identificador" :state="$empty(errores.identificador)" trim></b-form-input>
          <b-form-text>Nombre corto para esta alerta sin espacios ni caracteres especiales. Ej. presuntoCasoCovid</b-form-text>
        </b-form-group>

        <b-form-group label="Selecciona un tipo de alerta:" label-for="select-tipo-alerta" :invalid-feedback="errores.tipo">
          <b-form-select id="select-tipo-alerta" v-model="alerta.tipo" :state="$empty(errores.tipo)">
            <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
            <b-form-select-option v-for="tipo in alertasTipos" :key="tipo.key" :value="tipo.key">{{ tipo.value }}</b-form-select-option>
          </b-form-select>
          <b-form-text>Tipo de alerta</b-form-text>
          <b-form-text>Predefinida por el sistema: Son alertas programadas dentro del sistema Ej. temperatura</b-form-text>
          <b-form-text>Defnidas por el administrador: Son alertas programadas mediante una condición dinámica establecida por el administrador</b-form-text>
          <b-form-text>Manuales: Son alertes que el usuario debe seleccionar al momento de hacer el ingreso</b-form-text>
        </b-form-group>

        <b-form-group label="Selecciona una accion para esta alerta:" label-for="select-tipo-alerta" :invalid-feedback="errores.tipo">
          <b-form-select id="select-tipo-alerta" v-model="alerta.accion" :state="$empty(errores.tipo)">
            <b-form-select-option :value="null">Selecciona una opción</b-form-select-option>
            <b-form-select-option v-for="accion in alertasAcciones" :key="accion.key" :value="accion.key">{{ accion.value }}</b-form-select-option>
          </b-form-select>
          <b-form-text>Acción recomendada para la alerta</b-form-text>
        </b-form-group>

        <b-form-group label="Condición:" label-for="input-condicion" :invalid-feedback="errores.condicion" v-if="alerta.tipo === 'AUTOMATICA'">
          <b-form-textarea id="input-condicion" v-model="alerta.condicion" :state="$empty(errores.condicion)" trim></b-form-textarea>
          <b-form-text>Utilice respuestas.&lt;identificador&gt; para referenciar las respuestas de la encuesta de ingreso <b-link @click="respuestasModal = true">?</b-link>
          </b-form-text>
          <b-form-text>Utilice caracterizacion.&lt;identificador&gt; para referenciar los datos de caracterizacion <b-link @click="caracterizacionModal = true">?</b-link>
          </b-form-text>
          <b-form-text>Para utilizar una condición que dependa de un endpoint utilice: endpoint('tipo_de_alerta') o not(endpoint('tipo_de_alerta'))</b-form-text>
          <b-form-text>Variables extra disponibles para la condicion (codigo, perfil, aforoCompleto)</b-form-text>
        </b-form-group>

        <b-form-group label="Perfiles:" label-for="select-perfiles" :invalid-feedback="errores.perfiles" v-if="alerta.tipo !== 'PREDEFINIDA'">
          <b-form-checkbox-group id="select-perfiles" v-model="alerta.perfiles" :state="$empty(errores.perfiles)">
            <b-form-checkbox v-for="perfil in perfiles" :key="perfil.key" :value="perfil.key">{{ perfil.value }}</b-form-checkbox>
          </b-form-checkbox-group>
          <b-form-text>Perfiles para quienes estará disponible esta alerta</b-form-text>
        </b-form-group>

        <b-form-group label="Ingrese los correos a notificar" label-for="select-tipo-alerta" :invalid-feedback="errores.correos">
          <b-form-tags input-id="correos" v-model="alerta.correos" separator=" ,;" placeholder="Ingrese el correo y de click en add" :state="$empty(errores.correos)"></b-form-tags>
        </b-form-group>
        <b-form-text>A quienes se notificará si se activa esta alerta</b-form-text>
      </b-form>

      <template #modal-footer="{ cancel }">
        <b-button variant="success" @click="submit()">OK</b-button>
        <b-button variant="danger" @click="cancel()">Cancel</b-button>
      </template>

    </b-modal>

    <b-modal v-model="respuestasModal" size="lg" hide-backdrop>
      <div>
        <ul>
          <li v-for="pregunta in preguntasIngreso" :key="pregunta.identificador">
            <div class="font-weight-bold">{{ pregunta.identificador }}</div>
            <div v-if="pregunta.opciones_autocompletar.length > 0">
              <small>{{ pregunta.opciones_autocompletar.join(', ') }}</small>
            </div>
          </li>
        </ul>
      </div>
      <template #modal-footer="{ ok }">
        <b-button variant="success" @click="ok()">
          OK
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="caracterizacionModal" size="lg" hide-backdrop>
      <div>
        <ul>
          <li v-for="pregunta in preguntasCaracterizacion" :key="pregunta.identificador">
            <div class="font-weight-bold">{{ pregunta.identificador }}</div>
            <div v-if="pregunta.opciones_autocompletar.length > 0">
              <small>{{ pregunta.opciones_autocompletar.join(', ') }}</small>
            </div>
          </li>
        </ul>
      </div>
      <template #modal-footer="{ ok }">
        <b-button variant="success" @click="ok()">
          OK
        </b-button>
      </template>
    </b-modal>

  </section>
</template>

<script lang="ts">
import axios from 'axios'
import { Vue, Component, Watch } from 'vue-property-decorator'
import { url } from '../../../services/url_service'

@Component
export default class Alertas extends Vue {
  public mainModal: boolean = false
  public respuestasModal = false
  public caracterizacionModal = false
  errores: any = {}

  id?: number = null

  alerta: any = {
    tipo: 0,
    accion: 0,
    alerta: '',
    correos: [],
  }

  // Datos de db
  alertas: Array<any> = []
  alertasTipos: Array<any> = []
  alertasAcciones: Array<any> = []
  perfiles: Array<any> = []
  preguntasIngreso: Array<any> = []
  preguntasCaracterizacion: Array<any> = []

  campos: Array<any> = [
    {
      key: 'descripcion',
      label: 'Descripción',
    },
    {
      key: 'identificador',
      label: 'Identificador de alerta',
    },
    {
      key: 'tipo',
      label: 'Tipo',
    },
    {
      key: 'accion',
      label: 'Accion',
    },
    {
      key: 'correos',
      label: 'Correos',
    },
    {
      key: 'acciones',
    },
  ]

  public submit() {
    (this.$refs.mainForm as Element).dispatchEvent(new window.Event('submit'))
  }

  public async cargarAlertas() {
    let response = await axios.get(url.create('/internal/alertas'), {
      params: { limit: 1000 },
    })
    this.alertas = response.data.data
    //console.log(this.alertas)
  }

  public async cargarAlertasTipos() {
    let response = await axios.get(url.create('/public/enums/tipos_alerta'))
    this.alertasTipos = response.data
  }

  public async cargarAlertasAcciones() {
    let response = await axios.get(url.create('/public/enums/acciones_alerta'))
    this.alertasAcciones = response.data
  }

  public async cargarPerfiles() {
    let response = await axios.get(url.create(`/public/enums/perfiles`))
    this.perfiles = response.data
  }
  
  public async cargarPreguntasIngreso() {
    let response = await axios.get(url.create(`/internal/dinamicas/preguntas/ingreso`))
    this.preguntasIngreso = response.data
  }

  public async cargarPreguntasCaracterizacion() {
    let response = await axios.get(url.create(`/internal/dinamicas/preguntas/caracterizacion`))
    this.preguntasCaracterizacion = response.data
  }

  public async cargarDatos() {
    this.cargarAlertasTipos()
    this.cargarAlertasAcciones()
    this.cargarAlertas()
    this.cargarPerfiles()
    this.cargarPreguntasIngreso()
    this.cargarPreguntasCaracterizacion()
  }

  public textoTipo(tipo) {
    return this.alertasTipos.find(function (item) {
      return item.key === tipo
    })?.value || 'Sin tipo'
  }

  public textoAccion(accion) {
    return this.alertasAcciones.find(function (item) {
      return item.key === accion
    })?.value || 'Sin acción'
  }

  // Motodos para las alertas
  public async agregar() {
    this.errores = {}
    this.mainModal = true
    this.id = null
    this.alerta = {
      correos: [],
      alerta: '',
    }
  }

  public async editar(alerta) {
    this.errores = {}
    this.mainModal = true
    this.id = alerta.id
    this.alerta = {
      descripcion: alerta.descripcion,
      tipo: alerta.tipo,
      identificador: alerta.identificador,
      accion: alerta.accion,
      condicion: alerta.condicion,
      correos: alerta.correos,
      perfiles: alerta.perfiles,
    }
  }

  public async eliminar(alerta) {
    try {
      if (await this.$bvModal.msgBoxConfirm('¿Está seguro de que desea eliminar esta alerta?')) {
        await axios.delete(
          url.create(`/internal/alertas/${alerta.id}`)
        )
        this.cargarAlertas()
      }
    } catch (ex) {
      this.$bvModal.msgBoxOk('No se pudo elminar esta alerta', { okVariant: 'danger', })
    }
  }

  @Watch('alerta.tipo')
  public async alertaTipoChange(value) {
    if (value === 'PREDEFINIDA') {
      this.$set(this.alerta, 'perfiles', [])
    }
  }

  public async guardar() {
    try {
      this.errores = {}
      let promise = this.id
        ? axios.put(url.create(`/internal/alertas/${this.id}`), this.alerta)
        : axios.post(url.create(`/internal/alertas`), this.alerta)
      let response = await promise

      this.mainModal = false
      this.cargarAlertas()
    } catch (ex) {
      this.errores = ex.response.data
    }
  }

  public getValidationState({
    validated,
    dirty = null,
    valid = null,
    passed = null,
  }) {
    return validated || valid ? valid : null
  }

  public created() {
    this.cargarDatos()    
  }
}
</script>

<style lang="scss">
h2 small {
  font-size: 1rem;
}
</style>